export type RewardResult = 'granted' | 'dismissed' | 'unavailable' | 'failed';

export interface AdsProvider {
  initialize(): Promise<void>;
  showBanner(): Promise<void>;
  hideBanner(): Promise<void>;
  showInterstitial(): Promise<boolean>;
  prepareRewarded(): Promise<boolean>;
  showRewarded(): Promise<RewardResult>;
  isRewardedReady(): boolean;
}

export class NoopAdsProvider implements AdsProvider {
  initialize(): Promise<void> {
    return Promise.resolve();
  }

  showBanner(): Promise<void> {
    return Promise.resolve();
  }

  hideBanner(): Promise<void> {
    return Promise.resolve();
  }

  showInterstitial(): Promise<boolean> {
    return Promise.resolve(false);
  }

  prepareRewarded(): Promise<boolean> {
    return Promise.resolve(false);
  }

  showRewarded(): Promise<RewardResult> {
    return Promise.resolve('unavailable');
  }

  isRewardedReady(): boolean {
    return false;
  }
}

let adsProvider: AdsProvider = new NoopAdsProvider();

export function getAds(): AdsProvider {
  return adsProvider;
}

export function configureAds(provider: AdsProvider): void {
  adsProvider = provider;
}
